import { JobDocumentEntityType } from "@/lib/supabase/supabaseTypes";
import { ExtendedJobDocument, JobItemsForCalculations } from "./calculate";

/**
 * Converts an ExtendedJobDocument from the job_documents_extended_view 
 * to a standard JobDocumentEntityType and job items.
 */
export function convertExtendedJobDocumentToJdAndJi(
	extendedJobDocument: ExtendedJobDocument
): { jobDocument: JobDocumentEntityType, jobItems: JobItemsForCalculations[]} {
	return {
		jobDocument: {
			id: extendedJobDocument.job_document_id ?? 0,
			created_at: extendedJobDocument.job_document_created_at,
			modified_at: extendedJobDocument.job_document_modified_at,
			title: extendedJobDocument.job_document_title,
			created_by: extendedJobDocument.job_document_created_by,
			modified_by: extendedJobDocument.job_document_modified_by,
			job_id: extendedJobDocument.job_document_job_id ?? 0,
			type: extendedJobDocument.job_document_type,
			type_data: extendedJobDocument.job_document_type_data,
			status: extendedJobDocument.job_document_status ?? 0,
			amount: extendedJobDocument.job_document_amount,
			date: extendedJobDocument.job_document_date ?? "",
			discount_work: extendedJobDocument.job_document_discount_work,
			discount_material: extendedJobDocument.job_document_discount_material,
			code: extendedJobDocument.job_document_code,
			deleted_at: extendedJobDocument.job_document_deleted_at,
			work_title: extendedJobDocument.job_document_work_title,
			note: extendedJobDocument.job_document_note,
			fae_id: extendedJobDocument.job_document_fae_id
		},
		jobItems: extendedJobDocument.job_items
	};
}

/**
 * Converts an array of ExtendedJobDocuments to standard JobDocumentEntityType array
 */
export function convertExtendedToStandardJobDocuments(
	extendedJobDocuments: ExtendedJobDocument[]
): { jobDocument: JobDocumentEntityType, jobItems: JobItemsForCalculations[]}[] {
	return extendedJobDocuments.map(convertExtendedJobDocumentToJdAndJi);
}